import { BodyTextSmall, Dialog, DialogProps, FlexCol, FlexRow, PrimaryButton } from '@minecraft.atoms';
import React from 'react';

export type ConfirmationDialogProps = Pick<DialogProps, 'isOpen' | 'target'> & {
  /** context to tell the user what they are confirming */
  bodyText: string;
  /** label text for the cancel button */
  cancelText: string;
  /** event handler for the cancel button */
  onCancel: () => void;
  /** label text for the cofirm button */
  confirmText: string;
  /** event handler for the confirm button */
  onConfirm: () => void;
  /** disable in cancel / confirm buttons */
  disabled?: boolean;
};

/** A popover dialog that specifically asks a user to confirm or cancel an action */
export const ConfirmationDialog = ({
  bodyText,
  cancelText,
  onCancel,
  confirmText,
  onConfirm,
  disabled,
  isOpen,
  target,
}: ConfirmationDialogProps) => {
  // ensures that all required data is present
  if (!target || !bodyText || !isOpen || !cancelText || !onCancel || !confirmText || !onConfirm) {
    return null;
  }

  return (
    <Dialog target={target} isOpen={isOpen} data-testid="confirmation-dialog" data-qa-id="confirmation-dialog">
      <FlexCol w="full" gap="4" alignItems="center" justifyContent="center">
        <BodyTextSmall fontWeight="bold">{bodyText}</BodyTextSmall>
        <FlexRow w="full" gap="4">
          <PrimaryButton disabled={disabled} variant="secondary" label={cancelText} onClick={onCancel} />
          <PrimaryButton disabled={disabled} label={confirmText} onClick={onConfirm} />
        </FlexRow>
      </FlexCol>
    </Dialog>
  );
};
